import { _GettersTree, _StoreWithGetters, PiniaCustomProperties } from 'pinia';
import { UnwrapRef } from 'vue'
import { Patient, Identifier, Extension } from 'fhir/r4';
import moment from 'moment-timezone'

export type PatientGetters = {
  fullName: (state: UnwrapRef<Patient>) => string;
  smallName: (state: UnwrapRef<Patient>) => string;
  rut: (state: UnwrapRef<Patient>) => string;
  givenName: (state: UnwrapRef<Patient>) => string;
  lastName: (state: UnwrapRef<Patient>) => string;
  email: (state: UnwrapRef<Patient>) => string;
  phone: (state: UnwrapRef<Patient>) => string;
  benefits: (state: UnwrapRef<Patient>) => Identifier[];
  config: (state: UnwrapRef<Patient>) => Extension[];
  age: (state: UnwrapRef<Patient>) => number;
  insurance: (state: UnwrapRef<Patient>) => string;
  missingData: () => boolean;
}

const getters: PatientGetters & ThisType<UnwrapRef<Patient> & _StoreWithGetters<PatientGetters> & PiniaCustomProperties> & _GettersTree<Patient> = {
  fullName (state) {
    if (state.name && state.name[0] && state.name[0].given && state.name[0].family) {
      return `${state.name[0].given.join(' ')} ${state.name[0].family}`
    }
    return ''
  },
  smallName (state) {
    if (state.name && state.name[0] && state.name[0].given && state.name[0].family) {
      return `${state.name[0].given[0]} ${state.name[0].family}`
    }
    return ''
  },
  rut (state) {
    const identifier = state.identifier?.find((el) => el.system === 'RUT')
    if (identifier && identifier.value) {
      const splitted = identifier.value.split('-')
      return `${splitted[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')}-${splitted[1]}`
    } else return ''
  },
  givenName (state) {
    if (state.name && state.name[0] && state.name[0].given) {
      return state.name[0].given.join(' ')
    }
    return ''
  },
  lastName (state) {
    if (state.name && state.name[0] && state.name[0].family) {
      return state.name[0].family
    }
    return ''
  },
  email (state) {
    if (state.telecom) {
      const data = state.telecom.find((el) => el.system === 'email')
      return data && data.value ? data.value : ''
    }
    return ''
  },
  phone (state) {
    if (state.telecom) {
      const data = state.telecom.find((el) => el.system === 'phone')
      return data && data.value ? data.value : ''
    }
    return ''
  },
  benefits (state) {
    if (state.identifier) {
      return state.identifier.filter((el) => !['RUT', 'NOTIFICATIONS'].includes(el.system || ''))
    }
    return []
  },
  config (state) {
    if (state.extension) {
      return state.extension.find((el) => el.url === 'config-accelerate')?.extension || []
    }
    return []
  },
  age (state) {
    if (state.birthDate) {
      return moment().diff(moment(state.birthDate), 'years')
    }
    return 0
  },
  insurance (state) {
    if (state.extension) {
      return state.extension.find((el) => el.url === 'healthcare-prevition')?.valueString || ''
    }
    return ''
  },
  missingData () {
    if (this.fullName === '' || this.rut === '' || this.email === '' || this.phone === '', this.insurance === '') {
      return true
    }
    return false
  }
};

export default getters;
